import { FC, useMemo } from 'react';
import { ProposalResponse, ResultsResponse } from 'pages/ProposalDetail';
import {
  Box,
  HStack,
  Progress,
  Text,
  VStack,
  Tooltip,
  Stack
} from '@chakra-ui/react';
import formatNumber from 'utils/formatNumber';
import { formatLongNumbers } from 'utils/formatLongNumbers';

type Props = {
  proposal: ProposalResponse;
  results: ResultsResponse;
};

const ProposalResults: FC<Props> = ({ results, proposal }) => {
  const choices = useMemo(() => {
    return proposal.proposal.choices
      .map((choice, i) => ({ i, choice }))
      .sort(
        (a, b) =>
          results.results.resultsByVoteBalance[b.i] -
          results.results.resultsByVoteBalance[a.i]
      );
  }, [results, proposal]);

  return (
    <VStack alignItems='stretch' spacing={5}>
      {choices.map((choice, idx) => (
        <Box key={idx}>
          <Stack
            direction={['column', 'row']}
            justifyContent='space-between'
            mb={2}
          >
            <Tooltip label={choice.choice}>
              <Text maxW='180px' minW='20px' isTruncated>
                {choice.choice}
              </Text>
            </Tooltip>
            <HStack justifyContent='space-between' spacing={3}>
              <Tooltip
                hasArrow
                //TODO: Update TYPE to support number array within number array.
                //@ts-ignore
                label={results.results.resultsByStrategyScore[choice.i].map(
                  (v: string, i: number) => (
                    <div key={i}>
                      {isNaN(Number(v))
                        ? '0'
                        : Number(Number(v).toFixed(3)).toLocaleString()}{' '}
                      {proposal.proposal.strategies[i].params.symbol}
                    </div>
                  )
                )}
                fontSize='md'
                placement='top'
              >
                <Text>
                  {formatLongNumbers(
                    results.results.resultsByVoteBalance[choice.i]
                  )}{' '}
                  {proposal.space.symbol}
                </Text>
              </Tooltip>
              <Text>
                {formatNumber.percent(
                  !results.results.sumOfResultsBalance
                    ? 0
                    : ((100 / results.results.sumOfResultsBalance) *
                        results.results.resultsByVoteBalance[choice.i]) /
                        100
                )}
              </Text>
            </HStack>
          </Stack>
          <Progress
            borderRadius='md'
            size='sm'
            value={
              isNaN(results.results.resultsByVoteBalance[choice.i])
                ? 0
                : results.results.resultsByVoteBalance[choice.i]
            }
            max={
              results.results.sumOfResultsBalance > 0
                ? results.results.sumOfResultsBalance
                : 1
            }
          />
        </Box>
      ))}
    </VStack>
  );
};

export default ProposalResults;
